import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  HStack,
  Image,
  SkeletonText,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { FileBadgeIcon, ListTodo } from "lucide-react";
import { AiOutlineGroup } from "react-icons/ai";
import { BiCalendarEvent } from "react-icons/bi";
import { BsPeople } from "react-icons/bs";
import { CiSquareQuestion } from "react-icons/ci";
import { FaRegFileAlt } from "react-icons/fa";
import { GoDeviceCameraVideo } from "react-icons/go";
import { HiOutlineUserGroup } from "react-icons/hi";
import { IoFileTrayFull } from "react-icons/io5";
import { LuDollarSign } from "react-icons/lu";
import { MdEvent, MdOutlineAssessment } from "react-icons/md";
import { PiExam, PiFilesBold, PiIntersectThree } from "react-icons/pi";
import { RiFile2Fill } from "react-icons/ri";
import { RxFileText } from "react-icons/rx";
import { TbBasketQuestion } from "react-icons/tb";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../../../assets/logo.png";
const TeacherSidenavbar = () => {
  const isLoading = useSelector((state) => state.user.isLoading);
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  let navTabs = [
    {
      mainLabel: "المستخدمين",
      icon: <HiOutlineUserGroup size={24} />,
      children: [
        {
          label: " المجموعات",
          link: "/dashboard/groups",
          icon: <AiOutlineGroup size={24} />,
        },
        {
          label: " الطلاب",
          link: "/dashboard/students",
          icon: <BsPeople size={24} />,
        },
      ],
    },
    {
      mainLabel: "تقسيم المنهج",
      icon: <IoFileTrayFull size={24} />,
      children: [
        {
          label: "الفصول",
          link: "/dashboard/chapters",
          icon: <FaRegFileAlt size={24} />,
        },
        {
          label: "الاقسام",
          link: "/dashboard/sections",
          icon: <PiIntersectThree size={24} />,
        },
      ],
    },
    {
      mainLabel: "المحتوي التعليمي",
      icon: <RxFileText size={24} />,
      children: [
        {
          label: "الفيديوهات",
          link: "/dashboard/videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },
        {
          label: "الفيديوهات المباشرة",
          link: "/dashboard/live-videos",
          icon: <GoDeviceCameraVideo size={24} />,
        },

        {
          label: " بنك الاسئلة",
          link: "/dashboard/questions-bank",
          icon: <TbBasketQuestion size={24} />,
        },
        {
          label: "الاختبارات",
          link: "/dashboard/exams",
          icon: <PiExam size={24} />,
        },
        {
          label: "الواجبات",
          link: "/dashboard/homework",
          icon: <PiExam size={24} />,
        },
        { label: "المحتوى", link: "/dashboard/lessons", icon: <ListTodo /> },
        { label: "الأحداث", link: "/dashboard/events", icon: <MdEvent /> },
        { label: "الحصص", link: "/dashboard/lectures", icon: <MdEvent /> },
      ],
    },

    {
      mainLabel: " طلبات الطلاب",
      icon: <CiSquareQuestion size={24} />,
      children: [
        {
          label: "طلبات مشاهدة الفيديو",
          link: "/dashboard/videos-more-view-requests",
          icon: <BsPeople size={24} />,
        },
        {
          label: "طلبات اعادة الاختبار",
          link: "/dashboard/exam-redo-requests",
          icon: <BsPeople size={24} />,
        },
        {
          label: "امتحانات الطلاب",
          link: "/dashboard/student-exams",
          icon: <FileBadgeIcon />,
        },
      ],
    },
    {
      mainLabel: " الدفع",
      icon: <LuDollarSign size={24} />,
      children: [
        {
          label: "الحضور والدفع وتعويضات الحصص",
          link: "/dashboard/payments",
          icon: <BiCalendarEvent size={24} />,
        },
        {
          label: "المدفوعات",
          link: "/dashboard/payment-subjects",
          icon: <PiFilesBold size={24} />,
        },
        // {
        //   label: " الطلاب",
        //   link: "/dashboard/superadmin-students-payments",
        //   icon: <BsPeople size={24} />,
        // },
      ],
    },
    {
      mainLabel: "التقارير",
      icon: <MdOutlineAssessment size={24} />,
      children: [
        {
          label: "تقرير المجموعات",
          link: "/dashboard/groups-report",
          icon: <RiFile2Fill />,
        },
        {
          label: " الحضور",
          link: "/dashboard/attendence-report",
          icon: <RiFile2Fill />,
        },
        {
          label: " غياب الامتحانات",
          link: "/dashboard/exam-attendence-report",
          icon: <RiFile2Fill />,
        },
        {
          label: " حضور الامتحانات",
          link: "/dashboard/exam-report",
          icon: <RiFile2Fill />,
        },
        {
          label: " غياب الواجبات",
          link: "/dashboard/homework-absent-report",
          icon: <RiFile2Fill />,
        },
        {
          label: " حضور الواجبات",
          link: "/dashboard/homework-attendence-report",
          icon: <RiFile2Fill />,
        },
        {
          label: "تقرير مراجعة الواجبات",
          link: "/dashboard/uncomment-homework-report",
          icon: <RiFile2Fill />,
        },
        {
          label: "تقرير الواجبات الشامل",
          link: "/dashboard/homework-report-by-chapter",
          icon: <RiFile2Fill />,
        },
        {
          label: " تقرير مشاهدات الفيديوهات",
          link: "/dashboard/videos-report",
          icon: <RiFile2Fill />,
        },
        {
          label: "تقرير غياب المشاهدات",
          link: "/dashboard/videos-absent-report",
          icon: <RiFile2Fill />,
        },
        {
          label: "تقرير طباعة الاسئلة",
          link: "/dashboard/print-all-questions",
          icon: <RiFile2Fill />,
        },
        {
          label: " تقرير عدم الدفع",
          link: "/dashboard/unpaid-report",
          icon: <RiFile2Fill />,
        },
        {
          label: "رصد درجات السنتر",
          link: "/dashboard/attendence-simple-report",
          icon: <RiFile2Fill />,
        },
      ],
    },
  ];

  return (
    <Flex
      w={{ base: "100%", lg: "20%" }}
      p="0"
      h={{ base: "auto", lg: "100vh" }}
      flexDirection={"column"}
      zIndex="100"
      position={{ base: "relative", lg: "fixed" }}
      bg={{ base: "white", md: "#f5f5f5" }}
      borderLeft={{ base: "none", lg: "1px solid #45424226" }}
      alignItems={{ base: "flex-start", lg: "flex-start" }}
      className="scroll"
      overflowY={{ base: "visible", lg: "auto" }}
    >
      <Stack
        alignSelf={{ base: "flex-start", lg: "center" }}
        h={{ base: "80px", lg: "150px" }}
        w={{ base: "120px", lg: "auto" }}
        mx={{ base: "20px", lg: "auto" }}
        my={{ base: "10px", lg: "0" }}
      >
        <Image
          w="100%"
          h="100%"
          loading="lazy"
          src={Logo}
          alt="asquera"
          onClick={() => window.location.replace("/")}
          cursor="pointer"
        />
      </Stack>

      {isLoading ? (
        <HStack w="100%" bg="transparent" h="100%">
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={7}
            spacing="20"
          />
        </HStack>
      ) : (
        navTabs?.map((data, index) => {
          return data?.mainLabel ? (
            <Accordion
              allowMultiple
              w="100%"
              py={{ base: "5px", lg: "15px" }}
              px={{ base: "10px", lg: "0" }}
            >
              <AccordionItem border={0} w="100%">
                <h2 style={{ border: 0 }}>
                  <AccordionButton
                    justifyContent="space-between"
                    outline={0}
                    p={{ base: "10px", lg: "16px" }}
                    borderRadius="8px"
                    _hover={{ bg: "gray.50" }}
                    _active={{
                      outline: "0",
                      bg: "gray.100",
                    }}
                    _focus={{
                      outline: "0",
                    }}
                  >
                    <Box
                      textAlign="left"
                      display="flex"
                      alignItems="center"
                      gap={3}
                    >
                      {data?.icon}{" "}
                      <Text
                        style={{ fontSize: "16px", fontWeight: "500" }}
                        display={{ base: "block", lg: "block" }}
                      >
                        {data?.mainLabel}
                      </Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel
                  p={{ base: "0 5px", lg: 0 }}
                  pb={4}
                  pl={{ base: "20px", lg: "0" }}
                >
                  {data?.children?.map((val, childIndex) => (
                    <Link
                      to={val.link}
                      key={`${index}-${childIndex}`}
                      style={{ width: "90%" }}
                    >
                      <Flex
                        w="100%"
                        color="black"
                        alignItems="center"
                        justifyContent={{
                          base: "flex-start",
                          lg: "flex-start",
                        }}
                        mt="10px"
                        p={{ base: "15px", lg: "25px" }}
                        cursor="pointer"
                        h={{ base: "50px", lg: "" }}
                        bg={
                          window.location.pathname == val.link
                            ? "#e4e4e4"
                            : "transparent"
                        }
                        borderRadius="15px"
                        fontWeight={
                          window.location.pathname == val.link ? "600" : "400"
                        }
                        _hover={{
                          bg: "#e4e4e4",
                          fontWeight: "600",
                        }}
                      >
                        {val?.icon}
                        <Text
                          fontSize={{ base: "14px", lg: "16px" }}
                          mx="15px"
                          mt="2px"
                          display={{ base: "block", lg: "block" }}
                          color="main_1"
                        >
                          {val.label}
                        </Text>
                      </Flex>
                    </Link>
                  ))}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          ) : (
            <Link to={data.link} key={index} style={{ width: "90%" }}>
              <Flex
                w="100%"
                color="black"
                alignItems="center"
                justifyContent={{ base: "flex-start", lg: "flex-start" }}
                mt="10px"
                p={{ base: "15px", lg: "25px" }}
                cursor={"pointer"}
                h={{ base: "50px", lg: "" }}
                bg={
                  window.location.pathname == data.link
                    ? "#e4e4e4"
                    : "transparent"
                }
                // borderRadius="15px"
                fontWeight={
                  window.location.pathname == data.link ? "600" : "500"
                }
                _hover={{
                  bg: "#e4e4e4",
                  fontWeight: "600",
                }}
              >
                {data?.icon}
                <Text
                  fontSize={{ base: "14px", lg: "16px" }}
                  mx="15px"
                  mt="2px"
                  display={{ base: "block", lg: "block" }}
                  color="main_1"
                >
                  {data.label}
                </Text>
              </Flex>
            </Link>
          );
        })
      )}
    </Flex>
  );
};

export default TeacherSidenavbar;
